import styled from 'styled-components';

import ProviderPerformanceSection from './table/ProviderPerformanceSection';
import AvgStartOfCareTile from './tiles/AvgStartOfCareTile';
import EngagementsPerPatientTile from './tiles/EngagementsPerPatientTile';
import OESOverviewTile from './tiles/OESOverviewTile';
import ReadmissionRateOverviewTile from './tiles/ReadmissionRateOverviewTile';
import SafeReturnOverviewTile from './tiles/SafeReturnOverviewTile';
import ServiceRefusalsTile from './tiles/ServiceRefusalsTile';

const NetworkPerformanceDashboard = () => {
  return (
    <DashboardWrapper>
      <MetricsGrid>
        <AvgStartOfCareTile />
        <ServiceRefusalsTile />
        <SafeReturnOverviewTile />
        <OESOverviewTile />
        <EngagementsPerPatientTile />
        <ReadmissionRateOverviewTile />
      </MetricsGrid>
      <TableWrapper>
        <ProviderPerformanceSection />
      </TableWrapper>
    </DashboardWrapper>
  );
};

export default NetworkPerformanceDashboard;

const DashboardWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 394px));
  grid-gap: 24px;
  justify-content: center;

  @media (max-width: 1300px) {
    grid-template-columns: repeat(2, minmax(0, 394px));
  }

  @media (max-width: 960px) {
    grid-template-columns: minmax(0, 394px);
  }
`;

const MetricsGrid = styled.div`
  display: contents;
`;

const TableWrapper = styled.div`
  grid-column: 1 / -1;
`;
